import React from 'react'
import Ctalogo from '../../../assets/images/pajji.png';
import { Link } from 'react-router-dom';
import Star from '../../../assets/images/star-bottom.png'

const Ctaone = () => {
    return (
        <section className="cta-one" style={{ paddingTop: 24 }}>
            <div className="container">
                <div className="text-center mb-4" style={{ marginTop: 32 }}>
                    <h1 style={{ fontWeight: 500, fontSize: '2.5rem', marginBottom: 0, paddingBottom: 0, lineHeight: "40px" }}>
                        The strategic thought behind “Your trusted global experts”

                    </h1>
                    <img
                        src={Star}
                        className="img-fluid  w-60-mobile w-50"
                        style={{ marginTop: 0, paddingTop: 0, marginBottom: "2em", maxWidth: "60%" }}
                        alt=""
                    />
                    <div>
                        {/* <div style={{
                        width: 170,
                        margin: '12px auto 0 auto',
                        borderBottom: '2px solid #222',
                        position: 'relative',
                        height: 24,
                        display: 'inline',
                    }}/>
                        <span style={{
                            display: 'inline',
                            position: 'absolute',
                            left: '50%',
                            top: -16,
                            transform: 'translateX(-50%)',
                            background: '#fff',
                            padding: '0 12px',
                            fontSize: 24,
                            letterSpacing: 8
                        }}>
                            ★★★
                        </span>
                        <div style={{
                        width: 170,
                        margin: '12px auto 0 auto',
                        borderBottom: '2px solid #222',
                        position: 'relative',
                        height: 24,
                        display: "inline"
                    }}/> */}


                    </div>
                </div>
                <div className="row justify-content-center align-items-start" style={{ marginTop: 34 }} >
                    {/* Text Column */}
                    <div className="col-lg-6 col-md-12 col-12" id='force-left' style={{ padding: 20 }} >
                        <div style={{ fontSize: 15, lineHeight: 1.7, maxWidth: '100%' }}>
                            <p>
                            <span style={{ fontWeight: 600, fontSize: 18 }}>
                                A tagline is more than just a catchy phrase - it’s a brand
                                promise, a business differentiator. The choice of “Your Trusted
                                Global Experts” for The NRI Advisors was deliberate, aligning
                                with the organization’s core positioning and market needs.{' '}
                                <br />
                                Here's Why:
                            </span>
                            </p>

                            <span style={{ fontWeight: 600, fontSize: 18 }}>
                                1. Establishes Authority and Credibility
                            </span>
                            <p> “Experts” reinforces our deep specialization, signaling that you,
                                our valued client, aren't just getting advisors - you are getting
                                top-tier professionals with proven knowledge.
                            </p>
                            <p> In NRI services, trust is non-negotiable. The word “Trusted” was
                                intentionally placed first to position The NRI Advisors as a
                                reliable partner in all your local and global decision-making.
                            </p>

                            <span style={{ fontWeight: 600, fontSize: 18 }}>
                                2. Highlights Global Capability without Compromising Personalization
                            </span>
                            <p> We demonstrate global reach based on the strong foundations of
                                localized expertise that we have built in every market. “Global
                                Experts” subtly communicates that The NRI Advisors understands
                                cross-border complexities while still tailoring solutions.
                            </p>
                            <p> The word “Your” personalizes the message - it’s not just about our
                                credentials, but how those credentials serve YOUR unique needs.
                            </p>

                            <span style={{ fontWeight: 600, fontSize: 18 }}>
                                3. Competitive Differentiation
                            </span>
                            <p style={{ marginBottom: 0 }}>
                                It's easy to often use vague taglines which may lack specificity.
                                <br />
                                “Trusted Global Experts” is:
                            </p>
                            <ul style={{ marginBottom: 10, marginTop: 0, paddingTop: 0 }}>
                                <li>• Clear (no jargon)</li>
                                <li>• Memorable (simple yet powerful)</li>
                                <li>• Engaging (trust is a key buying factor in advisory services)</li>
                            </ul>

                            <span style={{ fontWeight: 600, fontSize: 18 }}>
                                4. Aligns with our Long-Term Positioning
                            </span>
                            <p> A strong tagline should scale with the organization’s growth. As
                                we expand into new markets and scale our services, “Your Trusted
                                Global Experts” remains relevant - flexible enough to evolve, yet
                                strong enough to anchor brand perception.
                            </p>

                            <span style={{ fontWeight: 600, fontSize: 18 }}>
                                5. A Tagline Built on Strategy, Not Just Words
                            </span>
                            <p> Every word in this tagline was chosen to reinforce The NRI
                                Advisors’s value proposition, build instant credibility, and
                                resonate with high-level decision-makers. It’s not just a
                                statement - it’s a strategic asset that shapes how the firm is
                                perceived in a crowded, competitive industry.
                            </p>

                            <span style={{ fontWeight: 600, fontSize: 18 }}>
                                At The NRI Advisors, trust isn’t claimed, it’s demonstrated.
                            </span>
                            <p> “Your Trusted Global Experts” is not just a tagline, it's a
                                promise. Every service, communication, and client relationship at
                                The NRI Advisors is built to live up to these four powerful words
                            </p>
                        </div>
                    </div>

                    {/* Image Column */}
                    <div className="col-lg-4 col-md-12 col-12 d-flex justify-content-center" style={{ padding: 20 }}>
                        <img
                            src={Ctalogo}
                            alt="Vivek Aggarwal"
                            style={{
                            width: '100%',
                            maxWidth: 500,
                            height: 'auto',
                            objectFit: 'cover',
                            borderRadius: 4,
                            boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
                            marginLeft: 14
                            // marginRight: 14
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Ctaone;